import axios from "axios";

export type CheckoutDisclaimer = {
    id: number;
    text: string;
    version: number;
};

/**
 * Fetches the active checkout disclaimer configured by the admin.
 * Returns null if no disclaimer is configured or the field is empty.
 */
export const fetchCheckoutDisclaimer = async (): Promise<CheckoutDisclaimer | null> => {
    try {
        const response = await axios.get("payments/checkout-disclaimer/", {
            withCredentials: true,
        });
        return response.disclaimer ?? null;
    } catch {
        return null;
    }
};
